const RECORDING_FILE_POLICY = {
    NONE: 0,
    ONLY_AUTO: 1,
    ONLY_MANUAL: 2,
    BOTH: 3,
};

const CHANNEL_KIND = {
    GENERAL: 0,
    PROGRAMMING: 1,
    WEBRTC: 2,
    CMAF: 3,
};
const PROFILE_GROUP_TYPE = {
    NORMAL: 0,
    WEBRTC: 1,
};

const ChannelConfig = {
    RECORDING_FILE_POLICY,
    CHANNEL_KIND,
    PROFILE_GROUP_TYPE,
};

export default ChannelConfig;
